import React from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';

import Main from './Main';
import PreAuthRoutes from 'Config/Routes/PreAuthRoutes';
import {ModalContainer} from 'Components/Partials/Layouts';

/**
 * @classdesc Unauthenticated handler
 */
export default class Unauthenticated extends Main {
    /**
     * @method render
     * @return {*}
     */
    render = () => {
        return (
            <BrowserRouter>
                <Switch>
                    {PreAuthRoutes.map((props) => this.renderRoute(props))}

                    <Route path="">
                        <Redirect to="/login" />
                    </Route>
                </Switch>

                <ModalContainer/>
            </BrowserRouter>
        );
    };
}
